import moment from 'moment';
export const column = (ctx) => {
  return [
    {
      prop: 'startDate',
      name: '起始月份',
      type: 'month',
      format: 'yyyy-MM',
      forecastMonth: false,
      disabled: false,
      span: 12,
    },
    {
      prop: 'endDate',
      name: '截止月份',
      type: 'month',
      format: 'yyyy-MM',
      forecastMonth: false,
      disabled: false,
      pickerSettleOptions: {
        disabledDate(time) {
          // 如果想包含本月本月 - 8.64e7 * t 就不需要了，
          // 如果想之前的不能选择把 > 换成 <
          let select = moment(time).format('YYYY-MM');
          return select < ctx.baseFormData.startDate;
        },
      },
      endDate: false,
      span: 12,
    },
    {
      prop: 'price',
      name: '电费单价：',
      type: 'inputAmount',
      placeholder: '请输入',
      precision: 4,
      max: 999999999,
      span: 12,
    },
    // {
    //   prop: 'servicePrice',
    //   name: '用电服务费单价：',
    //   type: 'inputAmount',
    //   placeholder: '请输入',
    //   precision: 2,
    //   max: 999999999,
    //   span: 12,
    // },
    {
      prop: 'remark',
      name: '备注：',
      type: 'input',
      maxlength: 100,
      placeholder: '请输入',
      span: 23,
    },
    {
      prop: 'createPersonName',
      name: '创建人：',
      type: 'input',
      placeholder: '请输入',
      span: 12,
      disabled: true,
    },
    {
      prop: 'gmtCreate',
      name: '创建时间：',
      type: 'date',
      placeholder: '',
      span: 12,
      disabled: true,
    },
  ];
};
